import "./BotaoContato.css";

function BotaoContato({ texto, rota, origem = "botao_contato" }) {
const handleClick = (e) => {
  e.preventDefault();
  e.stopPropagation();

  const params = new URLSearchParams(window.location.search);

  const metadata = {
    texto_botao: texto,
    url_destino: rota,

    device: window.innerWidth < 768 ? "mobile" : "desktop",
    screen: `${window.innerWidth}x${window.innerHeight}`,
    language: navigator.language,
    user_agent: navigator.userAgent,
    referrer: document.referrer || null,
    page_title: document.title,

    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_content: params.get("utm_content"),
    utm_term: params.get("utm_term"),

    timestamp_client: new Date().toISOString(),
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "whatsapp_click",
    origem,
    texto_botao: texto,
    url_destino: rota,
  });

  fetch("https://ca-tracking-api.vercel.app/api/events", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": "3f7c9e92-8a6d-4b1e-9f4a-2c6e5d8b7a01",
    },
    body: JSON.stringify({
      site_key: "dr-bruno-correa",
      site_name: "Dr Bruno Corrêa",
      site_url: window.location.origin,
      page_url: window.location.href,
      event_name: "whatsapp_click",
      origin: origem,

      // 👇 NOVO CAMPO
      campaign_name: params.get("utm_campaign") || null,

      metadata,
    }),
  })
    .catch(() => {})
    .finally(() => {
      setTimeout(() => {
        window.open(rota, "_blank", "noopener,noreferrer");
      }, 150);
    });
};

  return (
    <a
      href={rota}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="btn botao-contato scroll-reveal-opacity"
    >
      {texto}
    </a>
  );
}

export default BotaoContato;